export default __webpack_public_path__ + "static/media/polk_inventory_standard.69432d8f.png";